/**
 * «قوانین طوطی» (R13, owner decision 2026-10-13): while the server posts
 * every scored take to the feed (`features.autoPost`), each learner accepts
 * the feed rules once — a new account right after sign-in, before the
 * onboarding questions; an existing one on the next open of the app. The
 * text and its version are the server's (`social_status.consentText`,
 * `currentConsentVersion` — version 2 while auto-posting is on), so the
 * wording changes without a release. With `autoPost` off nothing is shown.
 *
 * The practice page keeps its own consent gate as a safety net for a learner
 * this one missed (say, the status could not be read at app open).
 */

/** What the app shows for a signed-in learner: their pages, a wait, or the rules. */
export function rulesView({ autoPost, phase, consentGiven }) {
  if (!autoPost) return 'pass'
  if (phase === 'idle' || phase === 'loading') return 'wait'
  // The status could not be read (offline): never lock the app over it —
  // the practice page asks again before the first take.
  if (phase === 'error') return 'pass'
  return consentGiven ? 'pass' : 'ask'
}

/** «ادامه» is live once the box is ticked, and not twice. */
export function canAccept({ checked, busy }) {
  return checked === true && !busy
}

/** The fields the rules screen shows, from a `social_status` answer. */
export function rulesOf(status) {
  return {
    consentGiven: status?.consentGiven === true,
    text: String(status?.consentText ?? '').trim(),
    version: Number.isInteger(status?.currentConsentVersion) ? status.currentConsentVersion : null,
  }
}
